module.exports = __webpack_public_path__ + "static/media/excel-recruitment.12e269dd.png";